import Model from './model.js';
import Decimal from 'decimal.js';
import Log from 'lib/log';
const log = Log('newModels/default-payroll-detail');
const excludedOvertime = ['Overtime (Wage)'] // ticket: PPKAN-340
export default class DefaultPayrollDetail extends Model {
    urlRoot() { return '/DefaultPayrollDetails'; }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    defaults() {
        return {
            companyId: null,
            rate: 0,
            unit: 0,
            amount: 0,
            isLocked: false,
            isUnpaidLeave: true,
            hiddenAt: null
        };
    }

    constraints() {
        return {
            payrollItemId: {presence: true},
            employeeId: {presence: true},
            amount: {
                presence: true
            },
            rate: function(value, attrs) {
                if (!attrs.payrollItemId) {
                    return null;
                }

                if (!app.payrollItems) {
                    return null;
                }

                const payrollItem = app.payrollItems.get(attrs.payrollItemId);
                if (!payrollItem || payrollItem.get('isUnit') !== true) {
                    return null;
                }

                return {
                    presence: true,
                    numericality: {greaterThanOrEqualTo: 0}
                };
            },
            unit: function(value, attrs) {
                if (!attrs.payrollItemId) {
                    return null;
                }

                if (!app.payrollItems) {
                    return null;
                }

                const payrollItem = app.payrollItems.get(attrs.payrollItemId);
                if (!payrollItem || payrollItem.get('isUnit') !== true) {
                    return null;
                }

                return {
                    presence: true,
                    numericality: {greaterThanOrEqualTo: 0}
                };
            },
            additionalInformation: function(value, attrs) {
                if (!attrs.payrollItemId) {
                    return null;
                }

                if (!app.payrollItems) {
                    return null;
                }

                const payrollItem = app.payrollItems.get(attrs.payrollItemId);
                if (!payrollItem || !payrollItem.get('additionalInfoClass')) {
                    return null;
                }

                return {presence: true};
            }
        };
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
        this.payrollItem = this.getPayrollItem();
        this.on('change:payrollItemId', this._setPayrollItem, this);
        this.on('change:rate change:unit', this.updateAmount, this);
        return this;
    }

    getPayrollItem() {
        if (this.payrollItem) {
            return this.payrollItem;
        }

        return this._setPayrollItem(this.get('payrollItemId'));
    }

    _setPayrollItem(id) {
        if (!app.payrollItems) {
            log.warn(`App hasn't any payroll items loaded`);
            return;
        }

        if (!id) {
            log.warn(`DefaultPayrollDetail doesn't have a payroll item`);
            return;
        }

        this.payrollItem = app.payrollItems.find(model => {
            return model.get('objectId') === id;
        });

        return this.payrollItem;
    }

    updateAmount() {
        if (this.isUnit()) {
            const roundedRate = new Decimal(this.get('rate'))
                .toDP(2, Decimal.ROUND_HALF_UP);
            const roundedUnit = new Decimal(this.get('unit'))
                .toDP(2, Decimal.ROUND_HALF_UP);

            this.set(
                'amount',
                roundedRate.times(roundedUnit)
                    .toDP(2, Decimal.ROUND_HALF_UP)
                    .toNumber()
            );
        }
    }

    getPayrollItemName() {
        const item = this.getPayrollItem();
        return (item && item.get('name')) || '';
    }

    getPayrollItemType() {
        const item = this.getPayrollItem();
        return item && item.get('type');
    }

    isUnit() {
        const item = this.getPayrollItem();
        return item.get('isUnit') === true;
    }

    isBase() {
        const item = this.getPayrollItem();
        return (
            item ? (item.get('type') === 'base') : false
        ) || false;
    }

    isOvertime() {
        const item = this.getPayrollItem();
        return (item && item.get('type') === 'overtime'
        && !excludedOvertime.includes(item.get('name')));
    }

    isAllowAffectOvertime() {
        const item = this.getPayrollItem();
        return item && !this.isOvertime() &&
            item.get('allowIsAffectOvertime') !== false;
    }

    isAllowUnpaidLeave() {
        const item = this.getPayrollItem();
        return item && (
            item.isAddition() || (
                item.isDeduction() && item.isCustom()
            ) || (
                item.get('allowIsUnpaidLeave') === true
            )
        );
    }

    //Bonus used to be a simple addition item but a change in the EPF calculator
    //required it to be split into a separate type.
    //For the intents and purposes of the UI, it is still very much an addition
    isAddition() {
        const item = this.getPayrollItem();
        return item && item.isAddition();
    }

    isZakat() {
        const item = this.getPayrollItem();
        return item.get('type') === 'zakat';
    }

    getRealAmount() {
        const item = this.getPayrollItem();
        const multiplier = (
            _.contains(
                ['deduction', 'zakat', 'mtd', 'epf', 'socso'],
                item.get('type')
            ) ? 1 : -1
        );
        return ((this.get('amount') || 0) * multiplier);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/default-payroll-detail.js